/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  API_FAIL,
  API_SUCCESS,
  SET_SELECTED_POLICY_ID,
  CLEAR_ERROR,
  SET_ERROR,
  FNOL_REPORT_DATE_VALIDATION_STATUS,
  SET_VALIDATE_STEP,
  SET_MEDICAL_AUTHORITY_FORM_LINK,
  SET_MEDICAL_CERTIFICATE_FORM_LINK,
  SET_CLAIM_TYPES,
  SET_VALIDATION_REPORT_DATE_ERROR,
  SET_JSON_VERSION,
  SET_INSURED_LIST,
  SET_CHILD_BENEFITS,
  SET_CLAIM_PAYMENT_VERSION,
  SET_IS_LINKED_COVER,
  SET_INCIDENT_DATE,
  SET_SHOW_ELECTRONIC_CONSENT,
  SET_EMAIL_ADDRESS,
  SET_PHONE_NUMBER,
  SET_CLIENT_ID,
  SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME,
  SET_TPA_NAME,
  SET_CARRIER_NAME,
  SET_SHOW_REQUIRE_DOCUMENT,
  SET_IS_CLAIM_GROUP_ALLOWED,
  SET_INIT_CLAIM_TYPES_SUCCESS,
  SET_ZURICH_UHC,
  SET_POLICY_PURCHASE_DATE,
  SET_POLICY_EFFECTIVE_DATE,
  SET_POLICY_TERMINATION_DATA,
  SET_CLAIMANT_ID,
  SET_GUARDIAN_CLIENT_ROLES,
  SET_APPSURE_INSTANCE_SCTI,
  SET_POLICY_CANCELLED,
  // SET_IS_FNOL_AUSTRALIA,
  // SET_IS_FNOL_NEW_ZEALAND,
  SET_CELLCAPTIVE_COUNTRY_ID,
  SET_POLICY_TYPE_CODE,
  SET_POLICY_PLAN_IDS,
  SET_SPECIFIED_ITEMS,
  SET_SHOW_TRAWICK_FNOL_REFACTORING,
  SET_EVENT_DESCRIPTION_LIMIT,
  SET_SHOW_TRAWICK_PAYMENT_SCREEN,
  VALIDATE_VERIFICATION_CODE,
  SET_CELL_CAPTIVE_NAME,
  SET_IS_SHOW_GST_QUESTION,
  SET_FORM_HAS_CHANGES,
  SET_SHOW_INSURED_MULTI_CLAIMANT,
  SET_ENABLE_FORM_DYNAMIC_PAYMENT_DETAIL,
  SET_SHOW_FNOL_AI_ANALYSIS,
} from './constants';


export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  };
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

export function apiError(error) {
  return {
    type: API_FAIL,
    error,
  };
}

export function apiSuccess(response) {
  return {
    type: API_SUCCESS,
    response,
  };
}

export function setSelectedPolicyId(policyId) {
  return {
    type: SET_SELECTED_POLICY_ID,
    policyId,
  };
}

export function setShowElectronicConsentDocument(showElectronicConsentDocument) {
  return {
    type: SET_SHOW_ELECTRONIC_CONSENT,
    showElectronicConsentDocument,
  };
}

export function setShowRequiredDocument(showRequiredDocument) {
  return {
    type: SET_SHOW_REQUIRE_DOCUMENT,
    showRequiredDocument,
  };
}

export function setShowZurichUHC(showZurichUHC) {
  return {
    type: SET_ZURICH_UHC,
    showZurichUHC,
  };
}

export function setShowTrawickFNOLRefactoring(showTrawickFNOLRefactoring) {
  return {
    type: SET_SHOW_TRAWICK_FNOL_REFACTORING,
    showTrawickFNOLRefactoring,
  };
}

export function setShowTrawickPaymentScreen(showTrawickPaymentScreen) {
  return {
    type: SET_SHOW_TRAWICK_PAYMENT_SCREEN,
    showTrawickPaymentScreen,
  };
}

export function setIsClaimGroupAllowed(isClaimGroupAllowed) {
  return {
    type: SET_IS_CLAIM_GROUP_ALLOWED,
    isClaimGroupAllowed,
  };
}

export function setCellCaptiveCountryId(cellCaptiveCountryId) {
  return {
    type: SET_CELLCAPTIVE_COUNTRY_ID,
    cellCaptiveCountryId,
  };
}

export function setPolicyTypeCode(policyTypeCode) {
  return {
    type: SET_POLICY_TYPE_CODE,
    policyTypeCode,
  };
}

export function setPolicyPlanIds(policyPlanIds) {
  return {
    type: SET_POLICY_PLAN_IDS,
    policyPlanIds,
  };
}

export function setSpecifiedItems(specifiedItems) {
  return {
    type: SET_SPECIFIED_ITEMS,
    specifiedItems,
  };
}

export function setDeclarationClaimsAdminCompanyName(declarationClaimsAdminCompanyName) {
  return {
    type: SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME,
    declarationClaimsAdminCompanyName,
  };
}

export function setTPAName(tpaName) {
  return {
    type: SET_TPA_NAME,
    tpaName,
  };
}

export function setCarrier(carrier) {
  return {
    type: SET_CARRIER_NAME,
    carrier,
  };
}

export function setClaimantId(claimantId) {
  return {
    type: SET_CLAIMANT_ID,
    claimantId,
  };
}

export function setEmailAddressLogin(emailAddressLogin) {
  return {
    type: SET_EMAIL_ADDRESS,
    emailAddressLogin,
  };
}

export function setPhoneNumberLogin(phoneNumberLogin) {
  return {
    type: SET_PHONE_NUMBER,
    phoneNumberLogin,
  };
}

export function setError(error) {
  return {
    type: SET_ERROR,
    error,
  };
}

export function clearError() {
  return {
    type: CLEAR_ERROR,
  };
}

export function setFnolReportDateValidation(status) {
  return {
    type: FNOL_REPORT_DATE_VALIDATION_STATUS,
    status,
  };
}

export function setValidateStep(step) {
  return {
    type: SET_VALIDATE_STEP,
    step,
  };
}

export function setMedicalAuthorityFormLink(link) {
  return {
    type: SET_MEDICAL_AUTHORITY_FORM_LINK,
    link,
  };
}

export function setMedicalCertificateFormLink(link) {
  return {
    type: SET_MEDICAL_CERTIFICATE_FORM_LINK,
    link,
  };
}

export function setClaimTypes(data, policyTypeId) {
  return {
    type: SET_CLAIM_TYPES,
    data,
    policyTypeId,
  };
}

export function setChildBenefits(data, policyTypeId) {
  return {
    type: SET_CHILD_BENEFITS,
    data,
    policyTypeId,
  };
}

export function setErrorMessageDateValidation(errorMessage) {
  return {
    type: SET_VALIDATION_REPORT_DATE_ERROR,
    errorMessage,
  };
}

export function setJSONVersion(version) {
  return {
    type: SET_JSON_VERSION,
    version,
  };
}

export function setInsuredList(insuredList) {
  return {
    type: SET_INSURED_LIST,
    insuredList,
  };
}

export function setGuardianClientRoles(guardianClientRoles) {
  return {
    type: SET_GUARDIAN_CLIENT_ROLES,
    guardianClientRoles,
  };
}

export function setClaimPaymentVersion(claimPaymentVersion) {
  return {
    type: SET_CLAIM_PAYMENT_VERSION,
    claimPaymentVersion,
  };
}

export function setIsLinkedCover(isLinkedCover) {
  return {
    type: SET_IS_LINKED_COVER,
    isLinkedCover,
  };
}

export function setIncidentDate(incidentDate) {
  return {
    type: SET_INCIDENT_DATE,
    incidentDate,
  };
}

export function setSelectedClientId(clientId) {
  return {
    type: SET_CLIENT_ID,
    clientId,
  };
}

export function getInitClaimTypeSuccess(claim) {
  return {
    type: SET_INIT_CLAIM_TYPES_SUCCESS,
    claimTypeList: claim.claimTypeList,
  };
}

export function setPolicyPurchaseDate(policyPurchaseDate) {
  return {
    type: SET_POLICY_PURCHASE_DATE,
    policyPurchaseDate,
  };
}

export function setPolicyEffectiveDate(policyEffectiveDate) {
  return {
    type: SET_POLICY_EFFECTIVE_DATE,
    policyEffectiveDate,
  };
}

export function setPolicyTerminationDate(policyTerminationDate) {
  return {
    type: SET_POLICY_TERMINATION_DATA,
    policyTerminationDate,
  };
}

export function setIsClaimForFieldEnabled(isClaimForFieldEnabled) {
  return {
    type: SET_APPSURE_INSTANCE_SCTI,
    isClaimForFieldEnabled,
  };
}

export function setIsPolicyCancelled(isPolicyCancelled) {
  return {
    type: SET_POLICY_CANCELLED,
    isPolicyCancelled,
  };
}

export function setEventDescriptionLimit(eventDescriptionLimit) {
  return {
    type: SET_EVENT_DESCRIPTION_LIMIT,
    eventDescriptionLimit,
  };
}

export function setCellCaptiveName(cellCaptiveName) {
  return {
    type: SET_CELL_CAPTIVE_NAME,
    cellCaptiveName,
  };
}

export function setIsShowGstQuestion(isShowGstQuestion) {
  return {
    type: SET_IS_SHOW_GST_QUESTION,
    isShowGstQuestion,
  };
}

export function setFormHasChanges(hasFormChanges) {
  return {
    type: SET_FORM_HAS_CHANGES,
    hasFormChanges,
  };
}


export function validateVerificationCodeRequest(payload) {
  return {
    type: VALIDATE_VERIFICATION_CODE,
    payload,
  };
}

export function setShowInsuredMultiClaimant(showInsuredMultiClaimant) {
  return {
    type: SET_SHOW_INSURED_MULTI_CLAIMANT,
    showInsuredMultiClaimant,
  };
}

export function setShowFnolAiAnalysis(showFnolAiAnalysis) {
  return {
    type: SET_SHOW_FNOL_AI_ANALYSIS,
    showFnolAiAnalysis,
  };
}

export function setEnableFormDynamicPaymentDetail(enableFormDynamicPaymentDetail) {
  return {
    type: SET_ENABLE_FORM_DYNAMIC_PAYMENT_DETAIL,
    enableFormDynamicPaymentDetail,
  };
}



// WEBPACK FOOTER //
// ./app/containers/App/actions.js